import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const AvatarMeta: ComponentMeta = {
  componentName: "Avatar",
  package: "@mijadesign/web",
  title: "头像",
  description: "用于展示用户头像或图片",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "UserOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "src",
      label: "图片地址",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "alt",
      label: "替代文本",
      type: PropType.STRING,
      group: "内容",
    },
    {
      name: "icon",
      label: "图标",
      type: PropType.STRING,
      description: "设置图标类型，如：UserOutlined",
      group: "图标",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "default" },
        { label: "小", value: "small" },
      ],
      group: "样式",
    },
    {
      name: "shape",
      label: "形状",
      type: PropType.ENUM,
      defaultValue: "circle",
      options: [
        { label: "圆形", value: "circle" },
        { label: "正方形", value: "square" },
      ],
      group: "样式",
    },
    {
      name: "gap",
      label: "文字与边框间距",
      type: PropType.NUMBER,
      defaultValue: 4,
      group: "样式",
    },
    {
      name: "crossOrigin",
      label: "跨域属性",
      type: PropType.ENUM,
      options: [
        { label: "匿名", value: "anonymous" },
        { label: "使用凭证", value: "use-credentials" },
      ],
      group: "高级",
    },
  ],
  defaultProps: {
    size: "default",
    shape: "circle",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Avatar",
  },
  snippet: {
    componentName: "Avatar",
    package: "@mijadesign/web",
    props: { icon: "UserOutlined", size: "default" },
  },
};

export const AvatarGroupMeta: ComponentMeta = {
  componentName: "Avatar.Group",
  package: "@mijadesign/web",
  title: "头像组",
  description: "显示多个头像的组合",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "TeamOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "maxCount",
      label: "最大显示数量",
      type: PropType.NUMBER,
      defaultValue: 4,
      group: "功能",
    },
    {
      name: "maxStyle",
      label: "超出样式",
      type: PropType.OBJECT,
      group: "样式",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "default" },
        { label: "小", value: "small" },
      ],
      group: "样式",
    },
    {
      name: "maxPopoverPlacement",
      label: "弹出位置",
      type: PropType.ENUM,
      defaultValue: "top",
      options: [
        { label: "顶部", value: "top" },
        { label: "底部", value: "bottom" },
      ],
      group: "功能",
    },
  ],
  defaultProps: {
    maxCount: 4,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Avatar",
  },
  snippet: {
    componentName: "Avatar.Group",
    package: "@mijadesign/web",
    props: { maxCount: 4 },
  },
};
